import React from "react";

export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="relative pt-36 md:pt-40 pb-16 text-center border-b hairline bg-viimii-2 overflow-hidden">
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full blur-3xl opacity-25" style={{ background: "radial-gradient(circle, rgba(201,161,90,0.35), transparent 70%)" }} />
      <div className="relative max-w-3xl mx-auto px-5">
        {eyebrow && <p className="section-line text-gold mb-4">{eyebrow}</p>}
        <h1 className="font-display text-5xl md:text-6xl font-semibold leading-tight">
          <span className="gold-gradient-text italic">{title}</span>
        </h1>
        {subtitle && <p className="mt-5 text-cream/65 max-w-xl mx-auto leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
